




















































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import axios from 'axios'
import { Result } from '../../../modules/class/RegisterResponseInfo'
import RegisteredUserInfo, {
  UserInfoModel
} from '../../../modules/class/RegisteredUserInfo'
import Item from '../../../modules/class/Item'
import ErrorFormResponse from '../../../modules/class/ErrorFormResponse'
import { membershipState } from '../../../store/modules/MembershipState'
import JsonUtil from '../../../modules/util/JsonUtil'
import PathUtil from '../../../modules/util/PathUtil'
import UidCookie from '../../../modules/util/UidSetCookie'
import { SapLoginInfo, ssoLogin } from '../../../modules/util/SapUtil'

const EMAIL_URL = PathUtil.makePath('/member/s/setting/email.html')
const UNREGISTER_URL = PathUtil.makePath('/member/s/setting/unregister.html')
const PASSWORD_URL = PathUtil.makePath('/member/s/setting/password.html')

@Component({
  components: {}
})
export default class ChangeMembershipInput extends Vue {
  private readonly vueid = 'vue_change_membership_input'

  // -------------------------------------------------------------------------------------------------------------------
  // props
  @Prop() private productCategory!: Item[]
  @Prop() private field!: Item[]

  // -------------------------------------------------------------------------------------------------------------------
  // data
  private emailUrl = EMAIL_URL
  private unregisterUrl = UNREGISTER_URL
  private passwordUrl = PASSWORD_URL

  private result: Result = 'success'
  private isErrorMessageAreaVisible = false
  private userInfo: RegisteredUserInfo = {
    result: false,
    email: '',
    firstname: '',
    lastname: '',
    password: '',
    organization: '',
    jobRoles: '',
    phone: '',
    mobilePhone: '',
    countryRegion: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    department: '',
    industry: '',
    emailSubscription: false,
    productCategory: [],
    field: [],
    updateDttm: ''
  }

  private resultError: ErrorFormResponse = {}
  private uidcookie = new UidCookie()

  // -------------------------------------------------------------------------------------------------------------------
  // hooks
  private mounted() {
    if (document.getElementById(this.vueid) !== null) {
      // Membership stateのuserInfoの必須項目に値が無い場合
      // 入力画面での更新が無いと判断し、APIからユーザ情報を取得する。
      if (membershipState.userInfo.updateDttm === '') {
        this.fetchUserInfo()
      } else {
        this.userInfo = membershipState.userInfo
      }
    }
  }

  // -------------------------------------------------------------------------------------------------------------------
  // methods
  /**
   * 登録されているログイン会員情報を取得する。
   */
  private async fetchUserInfo() {
    window.gigya.accounts.verifyLogin({
      include: 'preferences',
      callback: this.verifyLoginUserResponse
    })
  }

  /**
   * ログインユーザ情報取得コールバック
   */
  private async verifyLoginUserResponse(response: {
    errorCode: number
    UID: string
    UIDSignature: string
    signatureTimestamp: string
  }) {
    if (response.errorCode === 0) {
      const info: SapLoginInfo = {
        UID: response.UID,
        UIDSignature: response.UIDSignature,
        signatureTimestamp: response.signatureTimestamp
      }

      // Cookieに３点セットをセット
      this.uidcookie.setUid(info)

      const form = JSON.stringify({
        accountInfo: info
      })
      const res = await axios.post(
        PathUtil.makePath('/member/api/login_user'),
        form
      )
      if (res === undefined || res.status !== 200) {
        return
      }
      const model: UserInfoModel = JsonUtil.jsonToObject(
        UserInfoModel,
        res.data
      )
      this.userInfo = new RegisteredUserInfo(model)
    } else {
      // ログインしていないときはCookieを消す
      this.uidcookie.unSetUid()
    }
  }

  private async submit() {
    window.gigya.accounts.verifyLogin({
      include: 'preferences',
      callback: this.verifyLoginEditConfirmResponse
    })
  }

  /**
   * 興味分野確認コールバック
   */
  private async verifyLoginEditConfirmResponse(response: {
    errorCode: number
    UID: string
    UIDSignature: string
    signatureTimestamp: string
  }) {
    if (response.errorCode === 0) {
      const info: SapLoginInfo = {
        UID: response.UID,
        UIDSignature: response.UIDSignature,
        signatureTimestamp: response.signatureTimestamp
      }

      // Cookieに３点セットをセット
      this.uidcookie.setUid(info)

      const form = JSON.stringify({
        product_category: this.userInfo.productCategory,
        field: this.userInfo.field,
        update_dttm: this.userInfo.updateDttm,
        accountInfo: info
      })
      try {
        const res = await axios.post(
          PathUtil.makePath('/member/api/user_edit_confirm'),
          form
        )
        this.result = res.data.result
        if (this.result === 'success') {
          window.scrollTo({ top: 0 })
          this.isErrorMessageAreaVisible = false
          membershipState.addCurrentChangeMembershipStep('confirmation')
          membershipState.addUserInfo(this.userInfo)
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' })
          this.resultError = JsonUtil.jsonToObject<ErrorFormResponse>(
            ErrorFormResponse,
            res.data.errordata || {}
          )
          if (
            this.resultError.common !== undefined ||
            this.resultError.updateDttm !== undefined
          ) {
            this.isErrorMessageAreaVisible = true
          }
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status === 403) {
          ssoLogin(window.location.href, 'gigya-login-screen')
        } else {
          // TODO: システムエラー
        }
      }
    } else {
      // ログインしていないときはCookieを消す
      this.uidcookie.unSetUid()
    }
  }
}
